import { isInfoActivity, joinPath } from "./Helpers";
export default class ActivitiesService {
    async loadActivity(activityJsonPath) {
        const response = await fetch(activityJsonPath);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al cargar la actividad.');
        }
        const activity = await response.json();
        this.resolveActivityPaths(activity, activityJsonPath);
        return activity;
    }
    resolveActivityPaths(activity, activityJsonPath) {
        const activityFolder = activityJsonPath.substring(0, activityJsonPath.lastIndexOf('/'));
        if (isInfoActivity(activity)) {
            activity.images.forEach(image => {
                image.url = joinPath(activityFolder, image.url);
            });
            if (activity.audio) {
                activity.audio = joinPath(activityFolder, activity.audio);
            }
        }
    }
}
